import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { DynamicText } from "@/ui/DynamicText";
import { Button, Col, Row } from "react-bootstrap";
import { DynamicHtml } from "@/ui/DynamicHtml";
import ExternalLink from "@/assets/ExternalLink.svg";
import { useLink } from "@/hooks/useLink";
import Image from "@/ui/Image";

export const DiversityPageBannerSection = ({ className }) => {
  const locale = useLocale();
  const link = useLink();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`page.diversity.banner.title.${locale}`} tag="h1" />}
      image={{ path: "page.diversity.banner.image", src: "/assets/banners/default.webp" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.diversity.banner.text.${locale}`} className="me-4" />
        </Col>
        <Col xs={12} md={6}>
          <Image
            img={{ path: "page.diversity.banner.logo", src: "/assets/diversity/dei.png" }}
            size="626x396"
            className="w-100"
            alt=""
          />
        </Col>
        <Col xs={12}>
          <Button href={link("contact")} className="mt-3 mt-md-0" variant="primary">
            <DynamicText path={`page.diversity.banner.button.${locale}`} />
            <ExternalLink className="ms-3" width="20" height="20" />
          </Button>
        </Col>
      </Row>
    </Banner>
  );
};
